export default __webpack_public_path__ + "static/media/Group 2143.85b17b3f.svg";